<template>
  <Modal
    ref="modal"
    :id="id"
    type="confirm"
    :color="color"
    :maskClickClose="maskClickClose"
    :needClose="needClose"
    :needCancelBtn="needCancelBtn"
    :transition="transition"
    :cancelBtnColor="cancelBtnColor"
    :okBtnColor="okBtnColor"
    :btnSize="btnSize"
    :cancelBtnLabel="cancelBtnLabel"
    :okBtnLabel="okBtnLabel"
    :loading="loading"
    :needBtn="needBtn"
    :autoClose="autoClose"
    :useLockModal="useLockModal"
    @ok="handleOk"
    @cancel="handleCancel"
    @close="close"
    @destroy="destroy"
  >
    <div gk-confirm-title slot="title">{{title}}</div>
    <div class="gk-confirm-content" gk-confirm-content>
      <p gk-confirm-text v-for="(text, index) in message" :key="index">{{text}}</p>
    </div>
    
  </Modal>
</template>
 
<script>

import VueTypes from 'vue-types'

import Modal from './Modal'

import modalProps from './modal.props'
export default {
  name: 'comfirm-modal',
  components: {
    Modal
  },
  props: {
    /**
     * 自动销毁
     */
    ...modalProps,
    content: VueTypes.oneOfType([String, Array]).def(''),
    color: VueTypes.string.def('confirm'),
    useLockModal: VueTypes.bool.def(false)
  },
  data () {
    return {
      modal: null
    }
  },
  computed: {
    message () {
      return Array.isArray(this.content) ? this.content : this.content.split(',')
    }
  },
  created () {
  },
  mounted () {
    this.modal = this.$refs.modal
    setTimeout(() => {
      this.open()
    }, 10)
  },
  methods: {
    open () {
      this.modal && this.modal.showModal()
    },
    close () {
      this.$emit('close')
      this.modal && this.modal.close()
    },
    handleOk (params) {
      this.$emit('ok', params)
    },
    handleCancel (params) {
      this.$emit('cancel', params)
    },
    destroy () {
      setTimeout(() => {
        this.$emit('destroy')
      }, 500)
    }
  }
}
</script>
<style lang="scss" module>

</style>
 